import { dispatchClient } from '@dispatch/shared/services';
import { TaskRescheduleRequest } from '@dispatch/shared/types';
import { useMutation, useQueryClient } from 'react-query';

type ErrorResponse = {
  response: {
    data: {
      detail: string;
    };
    status: number;
  };
};

async function rescheduleTask(taskId: string, request: TaskRescheduleRequest) {
  return dispatchClient.post(
    `dispatch/service/tasks/${taskId}/status/rescheduled`,
    request
  );
}

export function useRescheduleTask(
  onSuccess: () => void,
  onError: (errorResponse: { status: number; message: string }) => void
) {
  const queryClient = useQueryClient();
  return useMutation(
    async ({
      taskId,
      request,
    }: {
      taskId: string;
      request: TaskRescheduleRequest;
    }) => rescheduleTask(taskId, request),
    {
      onSuccess,
      onError: (error: ErrorResponse) => {
        onError({
          status: error.response.status,
          message: error.response.data.detail,
        });
      },
      onSettled: () => {
        // Data that needs to be invalidated when task updates
        queryClient.invalidateQueries(['schedule-data']);
        queryClient.invalidateQueries(['schedule-data-infinite']);
        queryClient.invalidateQueries(['summaries']);
        queryClient.invalidateQueries(['task']);
        queryClient.invalidateQueries(['resource-tasks-assigned']);
        queryClient.invalidateQueries(['resource-tasks-unassigned']);
      },
    }
  );
}
